/**
 * Do not edit directly
 * Generated on Wed, 01 Apr 2026 07:50:27 GMT
 */

export const xs = "4px";
export const sm = "8px";
export const md = "16px";
export const lg = "32px";
export const xl = "64px";
